

export const GET_POKEMONES = 'GET_POKEMONES';
export const GET_TYPES = 'GET_TYPES';
export const GET_POK_BY_ID = 'GET_POK_BY_ID';
export const CREATE_POKEMON = 'CREATE_POKEMON';
export const SEARCH_POKEMON = 'SEARCH_POKEMON';
export const CLEAR_POKDETAIL = 'CLEAR_POKDETAIL';
export const CLEAR_SEARCH_RESULT = 'CLEAR_SEARCH_RESULT';
export const setLoading = 'setLoading';
export const setMsgDb = 'setMsgDb';
export const setMsgDbFail = 'setMsgDbFail';
export const setMsgDbName = 'setMsgDbName';
export const setFlag = 'SetFlag';
export const URL_BACK = 'https://api-pokemon-sh.herokuapp.com/'
//export const URL_BACK = 'http://localhost:3001/'


